export default function TermsAndConditions() {
    return (
        <div className="policy-page">
            <div className="policy-header">
                <h1>Terms & Conditions</h1>
                <p>Terms and conditions for using our services.</p>
            </div>

            <div className="policy-content">
                <h2>Terms and Conditions</h2>

                <p>
                    By using our website, you agree to the following terms.
                </p>

                <h3>Orders</h3>
                <ul>
                    <li>
                        All orders are subject to product availability and
                        confirmation.
                    </li>
                    <li>
                        Prices listed include applicable taxes unless mentioned
                        otherwise.
                    </li>
                </ul>

                <h3>Payments</h3>
                <ul>
                    <li>
                        We accept secure online payments via integrated payment
                        gateways.
                    </li>
                    <li>
                        Orders will be processed once payment is confirmed.
                    </li>
                </ul>

                <h3>Product Information</h3>
                <ul>
                    <li>
                        We make every effort to display accurate product details,
                        dimensions, and colors.
                    </li>
                    <li>
                        Actual product colors may slightly vary due to lighting
                        and screen differences.
                    </li>
                </ul>

                <h3>Use of Website</h3>

                <p>
                    You agree not to misuse the website or engage in unlawful
                    activities.
                </p>

                <h3>Contact</h3>

                <p>
                    For support, please contact:
                </p>

                <p>
                    <strong>GORE BOOK SELLER AND STATIONERY</strong>
                    <br />
                    Phone:{" "}
                    <a href="tel:9922815978">
                        9922815978
                    </a>
                    <br />
                    Email:{" "}
                    <a href="mailto:gorelearning.crm@gmail.com">
                        gorelearning.crm@gmail.com
                    </a>
                </p>

                <h2>सॉफ्टवेअर साठी</h2>

                <ul>
                    <li>
                        सदर सॉफ्टवेअर हे एका संगणकासाठी व एक वर्षासाठीच असेल.
                    </li>

                    <li>
                        हार्डवेअर नंबर बदल्यास कोणत्याही प्रकारची सेवा दिली जाणार
                        नाही.
                    </li>

                    <li>
                        सॉफ्टवेअर इंस्टॉल केल्यानंतर संगणक खराब झाल्यास त्याबदल्यात
                        दुसऱ्या संगणकावर ते इंस्टॉल करून दिले जाणार नाही त्यासाठी
                        पुन्हा पूर्ण रक्कम भरावी लागेल.
                    </li>

                    <li>
                        पैसे भरल्यानंतर सॉफ्टवेअर इंस्टॉल करण्यासाठी ५ ते ७ दिवस
                        लागू शकतात.
                    </li>

                    <li>
                        सदर सॉफ्टवेअर हे पूर्णत: विंडोबेस आहे.
                    </li>

                    <li>
                        सॉफ्टवेअर ऑनलाइन इंस्टॉल करून दिले जाईल.
                    </li>

                    <li>
                        सॉफ्टवेअरची रक्कम भरण्यापूर्वी{" "}
                        <a href="tel:9922553901">
                            9922553901
                        </a>{" "}
                        यावर कॉल करावा.
                    </li>
                </ul>

                <h3>Business Contact Information</h3>

                <p>
                    <strong>GORE BOOK SELLER AND STATIONERY</strong>
                    <br />
                    Contact:{" "}
                    <a href="tel:9922815978">
                        9922815978
                    </a>
                    <br />
                    Email:{" "}
                    <a href="mailto:gorelearning.crm@gmail.com">
                        gorelearning.crm@gmail.com
                    </a>
                </p>
            </div>
        </div>
    );
}